import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useMachine } from '@xstate/react';

import { useAuthContext } from '/src/hooks';
import { valueMachine } from '/src/features/goals/machines/wizard';
import { GoalValueWizard } from '/src/features/goals/components/GoalValueWizard';

export function Component() {
  const params = useParams();
  const navigate = useNavigate();
  const abTestId = params?.id ?? null;

  const { currentUser } = useAuthContext();
  const { defaultCurrency } = currentUser.settings;

  const [, , service] = useMachine(valueMachine, {
    devTools: true,
    context: {
      isEditing: true,
      goalId: Number(params.goalId),
      previousPath: abTestId ? `/ab-tests/${abTestId}/goals` : `/goals/${params.goalId}`,
      defaultCurrency: defaultCurrency || 'USD',
    },
  });

  useEffect(() => {
    const subscription = service.subscribe(async (state) => {
      if (state.matches('completed')) {
        navigate(`/goals/${params.goalId}`, { replace: true });
      }

      if (state.matches('cancelled')) {
        navigate(`/goals/${params.goalId}`, { replace: true });
      }
    });

    return subscription.unsubscribe;
  }, [navigate, params.goalId, service]);

  return <GoalValueWizard goalId={Number(params.goalId)} service={service} />;
}
